"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _moment = _interopRequireDefault(require("moment"));
function cov_1kaxqa4byh() {
  var path = "/home/node/project/src/timesheet.js";
  var hash = "a247b86245d814ced503c694418d090416a2b871";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/home/node/project/src/timesheet.js",
    statementMap: {
      "0": {
        start: {
          line: 3,
          column: 17
        },
        end: {
          line: 11,
          column: 1
        }
      },
      "1": {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 29,
          column: 6
        }
      },
      "2": {
        start: {
          line: 36,
          column: 4
        },
        end: {
          line: 39,
          column: 6
        }
      },
      "3": {
        start: {
          line: 44,
          column: 4
        },
        end: {
          line: 47,
          column: 16
        }
      },
      "4": {
        start: {
          line: 64,
          column: 18
        },
        end: {
          line: 64,
          column: 62
        }
      },
      "5": {
        start: {
          line: 65,
          column: 4
        },
        end: {
          line: 65,
          column: 36
        }
      },
      "6": {
        start: {
          line: 66,
          column: 4
        },
        end: {
          line: 66,
          column: 96
        }
      },
      "7": {
        start: {
          line: 68,
          column: 4
        },
        end: {
          line: 70,
          column: 10
        }
      },
      "8": {
        start: {
          line: 73,
          column: 4
        },
        end: {
          line: 133,
          column: 5
        }
      },
      "9": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 64
        }
      },
      "10": {
        start: {
          line: 76,
          column: 8
        },
        end: {
          line: 79,
          column: 10
        }
      },
      "11": {
        start: {
          line: 80,
          column: 8
        },
        end: {
          line: 80,
          column: 25
        }
      },
      "12": {
        start: {
          line: 82,
          column: 8
        },
        end: {
          line: 82,
          column: 64
        }
      },
      "13": {
        start: {
          line: 83,
          column: 8
        },
        end: {
          line: 83,
          column: 36
        }
      },
      "14": {
        start: {
          line: 84,
          column: 8
        },
        end: {
          line: 84,
          column: 60
        }
      },
      "15": {
        start: {
          line: 86,
          column: 8
        },
        end: {
          line: 88,
          column: 26
        }
      },
      "16": {
        start: {
          line: 89,
          column: 8
        },
        end: {
          line: 89,
          column: 60
        }
      },
      "17": {
        start: {
          line: 90,
          column: 8
        },
        end: {
          line: 93,
          column: 10
        }
      },
      "18": {
        start: {
          line: 94,
          column: 8
        },
        end: {
          line: 94,
          column: 25
        }
      },
      "19": {
        start: {
          line: 96,
          column: 8
        },
        end: {
          line: 99,
          column: 10
        }
      },
      "20": {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 100,
          column: 25
        }
      },
      "21": {
        start: {
          line: 102,
          column: 8
        },
        end: {
          line: 114,
          column: 9
        }
      },
      "22": {
        start: {
          line: 103,
          column: 10
        },
        end: {
          line: 107,
          column: 12
        }
      },
      "23": {
        start: {
          line: 109,
          column: 10
        },
        end: {
          line: 113,
          column: 12
        }
      },
      "24": {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 25
        }
      },
      "25": {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 129,
          column: 9
        }
      },
      "26": {
        start: {
          line: 118,
          column: 10
        },
        end: {
          line: 122,
          column: 12
        }
      },
      "27": {
        start: {
          line: 124,
          column: 10
        },
        end: {
          line: 128,
          column: 12
        }
      },
      "28": {
        start: {
          line: 130,
          column: 8
        },
        end: {
          line: 130,
          column: 25
        }
      },
      "29": {
        start: {
          line: 132,
          column: 8
        },
        end: {
          line: 132,
          column: 25
        }
      },
      "30": {
        start: {
          line: 143,
          column: 29
        },
        end: {
          line: 143,
          column: 45
        }
      },
      "31": {
        start: {
          line: 144,
          column: 4
        },
        end: {
          line: 153,
          column: 5
        }
      },
      "32": {
        start: {
          line: 152,
          column: 6
        },
        end: {
          line: 152,
          column: 36
        }
      },
      "33": {
        start: {
          line: 154,
          column: 4
        },
        end: {
          line: 154,
          column: 37
        }
      },
      "34": {
        start: {
          line: 164,
          column: 4
        },
        end: {
          line: 166,
          column: 5
        }
      },
      "35": {
        start: {
          line: 165,
          column: 6
        },
        end: {
          line: 165,
          column: 38
        }
      },
      "36": {
        start: {
          line: 168,
          column: 4
        },
        end: {
          line: 168,
          column: 37
        }
      },
      "37": {
        start: {
          line: 173,
          column: 25
        },
        end: {
          line: 173,
          column: 69
        }
      },
      "38": {
        start: {
          line: 174,
          column: 4
        },
        end: {
          line: 174,
          column: 41
        }
      },
      "39": {
        start: {
          line: 176,
          column: 18
        },
        end: {
          line: 176,
          column: 35
        }
      },
      "40": {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 198,
          column: 5
        }
      },
      "41": {
        start: {
          line: 189,
          column: 6
        },
        end: {
          line: 193,
          column: 30
        }
      },
      "42": {
        start: {
          line: 194,
          column: 6
        },
        end: {
          line: 196,
          column: 52
        }
      },
      "43": {
        start: {
          line: 196,
          column: 19
        },
        end: {
          line: 196,
          column: 50
        }
      },
      "44": {
        start: {
          line: 197,
          column: 6
        },
        end: {
          line: 197,
          column: 22
        }
      },
      "45": {
        start: {
          line: 199,
          column: 4
        },
        end: {
          line: 199,
          column: 69
        }
      },
      "46": {
        start: {
          line: 200,
          column: 4
        },
        end: {
          line: 202,
          column: 50
        }
      },
      "47": {
        start: {
          line: 202,
          column: 17
        },
        end: {
          line: 202,
          column: 48
        }
      },
      "48": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 203,
          column: 20
        }
      },
      "49": {
        start: {
          line: 207,
          column: 22
        },
        end: {
          line: 207,
          column: 37
        }
      },
      "50": {
        start: {
          line: 208,
          column: 21
        },
        end: {
          line: 217,
          column: 8
        }
      },
      "51": {
        start: {
          line: 211,
          column: 8
        },
        end: {
          line: 216,
          column: 9
        }
      },
      "52": {
        start: {
          line: 213,
          column: 12
        },
        end: {
          line: 213,
          column: 64
        }
      },
      "53": {
        start: {
          line: 215,
          column: 12
        },
        end: {
          line: 215,
          column: 51
        }
      },
      "54": {
        start: {
          line: 218,
          column: 4
        },
        end: {
          line: 218,
          column: 20
        }
      },
      "55": {
        start: {
          line: 228,
          column: 22
        },
        end: {
          line: 232,
          column: 5
        }
      },
      "56": {
        start: {
          line: 234,
          column: 4
        },
        end: {
          line: 236,
          column: 61
        }
      },
      "57": {
        start: {
          line: 245,
          column: 4
        },
        end: {
          line: 245,
          column: 56
        }
      },
      "58": {
        start: {
          line: 254,
          column: 4
        },
        end: {
          line: 254,
          column: 64
        }
      },
      "59": {
        start: {
          line: 269,
          column: 4
        },
        end: {
          line: 272,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 14,
            column: 2
          },
          end: {
            line: 14,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 48,
            column: 3
          }
        },
        line: 19
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 56,
            column: 2
          },
          end: {
            line: 56,
            column: 3
          }
        },
        loc: {
          start: {
            line: 60,
            column: 4
          },
          end: {
            line: 134,
            column: 3
          }
        },
        line: 60
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 142,
            column: 2
          },
          end: {
            line: 142,
            column: 3
          }
        },
        loc: {
          start: {
            line: 142,
            column: 48
          },
          end: {
            line: 155,
            column: 3
          }
        },
        line: 142
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 163,
            column: 2
          },
          end: {
            line: 163,
            column: 3
          }
        },
        loc: {
          start: {
            line: 163,
            column: 50
          },
          end: {
            line: 169,
            column: 3
          }
        },
        line: 163
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 171,
            column: 2
          },
          end: {
            line: 171,
            column: 3
          }
        },
        loc: {
          start: {
            line: 171,
            column: 65
          },
          end: {
            line: 204,
            column: 3
          }
        },
        line: 171
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 196,
            column: 13
          },
          end: {
            line: 196,
            column: 14
          }
        },
        loc: {
          start: {
            line: 196,
            column: 19
          },
          end: {
            line: 196,
            column: 50
          }
        },
        line: 196
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 202,
            column: 11
          },
          end: {
            line: 202,
            column: 12
          }
        },
        loc: {
          start: {
            line: 202,
            column: 17
          },
          end: {
            line: 202,
            column: 48
          }
        },
        line: 202
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 206,
            column: 2
          },
          end: {
            line: 206,
            column: 3
          }
        },
        loc: {
          start: {
            line: 206,
            column: 32
          },
          end: {
            line: 219,
            column: 3
          }
        },
        line: 206
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 210,
            column: 11
          },
          end: {
            line: 210,
            column: 12
          }
        },
        loc: {
          start: {
            line: 210,
            column: 21
          },
          end: {
            line: 217,
            column: 7
          }
        },
        line: 210
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 227,
            column: 2
          },
          end: {
            line: 227,
            column: 3
          }
        },
        loc: {
          start: {
            line: 227,
            column: 41
          },
          end: {
            line: 237,
            column: 3
          }
        },
        line: 227
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 244,
            column: 2
          },
          end: {
            line: 244,
            column: 3
          }
        },
        loc: {
          start: {
            line: 244,
            column: 35
          },
          end: {
            line: 246,
            column: 3
          }
        },
        line: 244
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 253,
            column: 2
          },
          end: {
            line: 253,
            column: 3
          }
        },
        loc: {
          start: {
            line: 253,
            column: 36
          },
          end: {
            line: 255,
            column: 3
          }
        },
        line: 253
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 264,
            column: 2
          },
          end: {
            line: 264,
            column: 3
          }
        },
        loc: {
          start: {
            line: 268,
            column: 4
          },
          end: {
            line: 273,
            column: 3
          }
        },
        line: 268
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 15,
            column: 4
          },
          end: {
            line: 15,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 15,
            column: 20
          },
          end: {
            line: 15,
            column: 31
          }
        }],
        line: 15
      },
      "1": {
        loc: {
          start: {
            line: 16,
            column: 4
          },
          end: {
            line: 16,
            column: 33
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 33
          }
        }],
        line: 16
      },
      "2": {
        loc: {
          start: {
            line: 17,
            column: 4
          },
          end: {
            line: 17,
            column: 18
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 17,
            column: 17
          },
          end: {
            line: 17,
            column: 18
          }
        }],
        line: 17
      },
      "3": {
        loc: {
          start: {
            line: 18,
            column: 4
          },
          end: {
            line: 18,
            column: 45
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 18,
            column: 16
          },
          end: {
            line: 18,
            column: 45
          }
        }],
        line: 18
      },
      "4": {
        loc: {
          start: {
            line: 57,
            column: 4
          },
          end: {
            line: 57,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 57,
            column: 13
          },
          end: {
            line: 57,
            column: 24
          }
        }],
        line: 57
      },
      "5": {
        loc: {
          start: {
            line: 58,
            column: 4
          },
          end: {
            line: 58,
            column: 24
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 58,
            column: 16
          },
          end: {
            line: 58,
            column: 24
          }
        }],
        line: 58
      },
      "6": {
        loc: {
          start: {
            line: 59,
            column: 4
          },
          end: {
            line: 59,
            column: 25
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 59,
            column: 16
          },
          end: {
            line: 59,
            column: 25
          }
        }],
        line: 59
      },
      "7": {
        loc: {
          start: {
            line: 64,
            column: 18
          },
          end: {
            line: 64,
            column: 62
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 64,
            column: 30
          },
          end: {
            line: 64,
            column: 49
          }
        }, {
          start: {
            line: 64,
            column: 52
          },
          end: {
            line: 64,
            column: 62
          }
        }],
        line: 64
      },
      "8": {
        loc: {
          start: {
            line: 68,
            column: 14
          },
          end: {
            line: 70,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 69,
            column: 8
          },
          end: {
            line: 69,
            column: 83
          }
        }, {
          start: {
            line: 70,
            column: 8
          },
          end: {
            line: 70,
            column: 9
          }
        }],
        line: 68
      },
      "9": {
        loc: {
          start: {
            line: 68,
            column: 14
          },
          end: {
            line: 68,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 68,
            column: 14
          },
          end: {
            line: 68,
            column: 37
          }
        }, {
          start: {
            line: 68,
            column: 41
          },
          end: {
            line: 68,
            column: 86
          }
        }],
        line: 68
      },
      "10": {
        loc: {
          start: {
            line: 73,
            column: 4
          },
          end: {
            line: 133,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 80,
            column: 25
          }
        }, {
          start: {
            line: 81,
            column: 6
          },
          end: {
            line: 94,
            column: 25
          }
        }, {
          start: {
            line: 95,
            column: 6
          },
          end: {
            line: 100,
            column: 25
          }
        }, {
          start: {
            line: 101,
            column: 6
          },
          end: {
            line: 115,
            column: 25
          }
        }, {
          start: {
            line: 116,
            column: 6
          },
          end: {
            line: 130,
            column: 25
          }
        }, {
          start: {
            line: 131,
            column: 6
          },
          end: {
            line: 132,
            column: 25
          }
        }],
        line: 73
      },
      "11": {
        loc: {
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 88,
            column: 25
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 12
          },
          end: {
            line: 87,
            column: 46
          }
        }, {
          start: {
            line: 88,
            column: 12
          },
          end: {
            line: 88,
            column: 25
          }
        }],
        line: 86
      },
      "12": {
        loc: {
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 86,
            column: 70
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 86,
            column: 24
          },
          end: {
            line: 86,
            column: 53
          }
        }, {
          start: {
            line: 86,
            column: 57
          },
          end: {
            line: 86,
            column: 70
          }
        }],
        line: 86
      },
      "13": {
        loc: {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }, {
          start: {
            line: 102,
            column: 8
          },
          end: {
            line: 114,
            column: 9
          }
        }],
        line: 102
      },
      "14": {
        loc: {
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        }, {
          start: {
            line: 117,
            column: 8
          },
          end: {
            line: 129,
            column: 9
          }
        }],
        line: 117
      },
      "15": {
        loc: {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }, {
          start: {
            line: 144,
            column: 4
          },
          end: {
            line: 153,
            column: 5
          }
        }],
        line: 144
      },
      "16": {
        loc: {
          start: {
            line: 145,
            column: 6
          },
          end: {
            line: 150,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 145,
            column: 6
          },
          end: {
            line: 149,
            column: 7
          }
        }, {
          start: {
            line: 150,
            column: 9
          },
          end: {
            line: 150,
            column: 72
          }
        }],
        line: 145
      },
      "17": {
        loc: {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 166,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 166,
            column: 5
          }
        }, {
          start: {
            line: 164,
            column: 4
          },
          end: {
            line: 166,
            column: 5
          }
        }],
        line: 164
      },
      "18": {
        loc: {
          start: {
            line: 171,
            column: 26
          },
          end: {
            line: 171,
            column: 40
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 171,
            column: 32
          },
          end: {
            line: 171,
            column: 40
          }
        }],
        line: 171
      },
      "19": {
        loc: {
          start: {
            line: 171,
            column: 42
          },
          end: {
            line: 171,
            column: 63
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 171,
            column: 54
          },
          end: {
            line: 171,
            column: 63
          }
        }],
        line: 171
      },
      "20": {
        loc: {
          start: {
            line: 173,
            column: 25
          },
          end: {
            line: 173,
            column: 69
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 173,
            column: 37
          },
          end: {
            line: 173,
            column: 56
          }
        }, {
          start: {
            line: 173,
            column: 59
          },
          end: {
            line: 173,
            column: 69
          }
        }],
        line: 173
      },
      "21": {
        loc: {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }, {
          start: {
            line: 185,
            column: 4
          },
          end: {
            line: 198,
            column: 5
          }
        }],
        line: 185
      },
      "22": {
        loc: {
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 187,
            column: 63
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 186,
            column: 6
          },
          end: {
            line: 186,
            column: 68
          }
        }, {
          start: {
            line: 187,
            column: 9
          },
          end: {
            line: 187,
            column: 63
          }
        }],
        line: 186
      },
      "23": {
        loc: {
          start: {
            line: 211,
            column: 8
          },
          end: {
            line: 216,
            column: 9
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 212,
            column: 10
          },
          end: {
            line: 213,
            column: 64
          }
        }, {
          start: {
            line: 214,
            column: 10
          },
          end: {
            line: 215,
            column: 51
          }
        }],
        line: 211
      },
      "24": {
        loc: {
          start: {
            line: 265,
            column: 4
          },
          end: {
            line: 265,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 265,
            column: 12
          },
          end: {
            line: 265,
            column: 31
          }
        }],
        line: 265
      },
      "25": {
        loc: {
          start: {
            line: 266,
            column: 4
          },
          end: {
            line: 266,
            column: 29
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 266,
            column: 10
          },
          end: {
            line: 266,
            column: 29
          }
        }],
        line: 266
      },
      "26": {
        loc: {
          start: {
            line: 267,
            column: 4
          },
          end: {
            line: 267,
            column: 31
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 267,
            column: 13
          },
          end: {
            line: 267,
            column: 31
          }
        }],
        line: 267
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0
    },
    b: {
      "0": [0],
      "1": [0],
      "2": [0],
      "3": [0],
      "4": [0],
      "5": [0],
      "6": [0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0, 0, 0, 0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0],
      "19": [0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0],
      "25": [0],
      "26": [0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a247b86245d814ced503c694418d090416a2b871"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1kaxqa4byh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1kaxqa4byh();
var weekDays = (cov_1kaxqa4byh().s[0]++, {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 0
});
var TimeSheets = /*#__PURE__*/function () {
  function TimeSheets() {
    var payrollPeriod = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kaxqa4byh().b[0][0]++, 'everyweek');
    var payrollPeriodStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1kaxqa4byh().b[1][0]++, 'monday');
    var cacheLimit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1kaxqa4byh().b[2][0]++, 3);
    var dateInput = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : (cov_1kaxqa4byh().b[3][0]++, (0, _moment["default"])().format('YYYY-MM-DD'));
    (0, _classCallCheck2["default"])(this, TimeSheets);
    cov_1kaxqa4byh().f[0]++;
    cov_1kaxqa4byh().s[1]++;
    /**
     * @constant
     * @type {Object}
     * @summary - Current Payroll Period drawn from system date & time
     */
    this.currentPeriod = this.constructor.getPeriodFrame(payrollPeriod, payrollPeriodStart, dateInput);

    /**
     * @constant
     * @type {Object[]}
     * @summary - Array of current week date objects
     */
    cov_1kaxqa4byh().s[2]++;
    this.currentWeek = this.constructor.weekFollowingDay(payrollPeriodStart, dateInput);
    /**
     * @type {String}
     * @summary - Date Limit of timesheets cache
     */
    cov_1kaxqa4byh().s[3]++;
    this.cacheLimit = (0, _moment["default"])(this.currentPeriod.periodStart).subtract(cacheLimit, 'weeks').startOf('day').format();
  }

  /**
   * @param {*} period - period increments eg ('everweek', 'everyotherweek', etc )
   * @param {*} weekStart - Weekday start of payroll period
   * @param {*} dateInput - User defined date
   * @returns - Payroll period (periodStart, periodEnd)
   */
  (0, _createClass2["default"])(TimeSheets, null, [{
    key: "getPeriodFrame",
    value: function getPeriodFrame() {
      var period = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kaxqa4byh().b[4][0]++, 'everyweek');
      var weekStart = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1kaxqa4byh().b[5][0]++, 'monday');
      var dateInput = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1kaxqa4byh().b[6][0]++, undefined);
      cov_1kaxqa4byh().f[1]++;
      var timeFrame;
      var startOfPeriod;
      var endOfPeriod;
      var weekOne = (cov_1kaxqa4byh().s[4]++, dateInput ? (cov_1kaxqa4byh().b[7][0]++, new Date(dateInput)) : (cov_1kaxqa4byh().b[7][1]++, new Date()));
      cov_1kaxqa4byh().s[5]++;
      weekOne.setUTCHours(0, 0, 0, 0);
      cov_1kaxqa4byh().s[6]++;
      weekOne = _moment["default"].utc(weekOne.toISOString()).startOf('year').isoWeekday(weekDays[weekStart]);
      cov_1kaxqa4byh().s[7]++;
      weekOne = (cov_1kaxqa4byh().b[9][0]++, weekOne.dayOfYear() > 1) && (cov_1kaxqa4byh().b[9][1]++, _moment["default"].utc(dateInput).year() > weekOne.year()) ? (cov_1kaxqa4byh().b[8][0]++, weekOne.clone().endOf('year').dayOfYear() - weekOne.clone().dayOfYear() + 1) : (cov_1kaxqa4byh().b[8][1]++, 0);

      /* console.log(weekOne) */
      cov_1kaxqa4byh().s[8]++;
      switch (period) {
        case 'everyweek':
          cov_1kaxqa4byh().b[10][0]++;
          cov_1kaxqa4byh().s[9]++;
          timeFrame = this.weekFollowingDay(weekStart, dateInput);
          cov_1kaxqa4byh().s[10]++;
          timeFrame = {
            periodStart: timeFrame[0].format(),
            periodEnd: timeFrame[6].endOf('day').format()
          };
          cov_1kaxqa4byh().s[11]++;
          return timeFrame;
        case 'everyotherweek':
          cov_1kaxqa4byh().b[10][1]++;
          cov_1kaxqa4byh().s[12]++;
          timeFrame = this.weekFollowingDay(weekStart, dateInput);
          cov_1kaxqa4byh().s[13]++;
          var _timeFrame = timeFrame;
          var _timeFrame2 = (0, _slicedToArray2["default"])(_timeFrame, 1);
          startOfPeriod = _timeFrame2[0];
          cov_1kaxqa4byh().s[14]++;
          weekOne = (startOfPeriod.dayOfYear() + weekOne) / 7;
          cov_1kaxqa4byh().s[15]++;
          startOfPeriod = (cov_1kaxqa4byh().b[12][0]++, Math.floor(weekOne) % 2 === 0) || (cov_1kaxqa4byh().b[12][1]++, weekOne >= 51) ? (cov_1kaxqa4byh().b[11][0]++, startOfPeriod.subtract(1, 'weeks')) : (cov_1kaxqa4byh().b[11][1]++, startOfPeriod);
          cov_1kaxqa4byh().s[16]++;
          endOfPeriod = startOfPeriod.clone().add(2, 'weeks');
          cov_1kaxqa4byh().s[17]++;
          timeFrame = {
            periodStart: startOfPeriod.format(),
            periodEnd: endOfPeriod.subtract(1, 'days').endOf('day').format()
          };
          cov_1kaxqa4byh().s[18]++;
          return timeFrame;
        case 'monthly':
          cov_1kaxqa4byh().b[10][2]++;
          cov_1kaxqa4byh().s[19]++;
          timeFrame = {
            periodStart: _moment["default"].utc(dateInput).startOf('month').format(),
            periodEnd: _moment["default"].utc(dateInput).endOf('month').format()
          };
          cov_1kaxqa4byh().s[20]++;
          return timeFrame;
        case 'firstandfifteenth':
          cov_1kaxqa4byh().b[10][3]++;
          cov_1kaxqa4byh().s[21]++;
          if (_moment["default"].utc(dateInput).date() <= 15) {
            cov_1kaxqa4byh().b[13][0]++;
            cov_1kaxqa4byh().s[22]++;
            timeFrame = {
              periodStart: _moment["default"].utc(dateInput).startOf('month').format(),
              periodEnd: _moment["default"].utc(dateInput).date(15).endOf('day').format()
            };
          } else {
            cov_1kaxqa4byh().b[13][1]++;
            cov_1kaxqa4byh().s[23]++;
            timeFrame = {
              periodStart: _moment["default"].utc(dateInput).date(16).startOf('day').format(),
              periodEnd: _moment["default"].utc(dateInput).endOf('month').format()
            };
          }
          cov_1kaxqa4byh().s[24]++;
          return timeFrame;
        case 'fifteenthandlast':
          cov_1kaxqa4byh().b[10][4]++;
          cov_1kaxqa4byh().s[25]++;
          if (_moment["default"].utc(dateInput).date() <= 15) {
            cov_1kaxqa4byh().b[14][0]++;
            cov_1kaxqa4byh().s[26]++;
            timeFrame = {
              periodStart: _moment["default"].utc(dateInput).startOf('month').format(),
              periodEnd: _moment["default"].utc(dateInput).date(15).endOf('day').format()
            };
          } else {
            cov_1kaxqa4byh().b[14][1]++;
            cov_1kaxqa4byh().s[27]++;
            timeFrame = {
              periodStart: _moment["default"].utc(dateInput).date(16).startOf('day').format(),
              periodEnd: _moment["default"].utc(dateInput).endOf('month').format()
            };
          }
          cov_1kaxqa4byh().s[28]++;
          return timeFrame;
        default:
          cov_1kaxqa4byh().b[10][5]++;
          cov_1kaxqa4byh().s[29]++;
          return timeFrame;
      }
    }

    /**
     * @param {String} date
     * @param {Object} payrollFrame
     * @returns {String}
     * @summary - Last Day of Entry Must not exceed Payroll Period
     */
  }, {
    key: "calculatePeriodEnd",
    value: function calculatePeriodEnd(date, payrollFrame) {
      cov_1kaxqa4byh().f[2]++;
      var lastTimeSheetDay = (cov_1kaxqa4byh().s[30]++, _moment["default"].utc(date));
      cov_1kaxqa4byh().s[31]++;
      if ((cov_1kaxqa4byh().b[16][0]++, !this.DateIsBetween(payrollFrame.periodStart, payrollFrame.periodEnd, (0, _moment["default"])(date).format())) && (cov_1kaxqa4byh().b[16][1]++, this.DateIsAfter((0, _moment["default"])(date).format(), payrollFrame.periodEnd))) {
        cov_1kaxqa4byh().b[15][0]++;
        cov_1kaxqa4byh().s[32]++;
        return payrollFrame.periodEnd;
      } else {
        cov_1kaxqa4byh().b[15][1]++;
      }
      cov_1kaxqa4byh().s[33]++;
      return lastTimeSheetDay.format();
    }

    /**
     * @function calculatePeriodStart
     * Edge Case:
     * @summary - Time sheet first day of the week is
     * before period start return {periodFrame.periodStart}
     */
  }, {
    key: "calculatePeriodStart",
    value: function calculatePeriodStart(date, payrollFrame) {
      cov_1kaxqa4byh().f[3]++;
      cov_1kaxqa4byh().s[34]++;
      if (this.DateIsAfter(payrollFrame.periodStart, (0, _moment["default"])(date).format())) {
        cov_1kaxqa4byh().b[17][0]++;
        cov_1kaxqa4byh().s[35]++;
        return payrollFrame.periodStart;
      } else {
        cov_1kaxqa4byh().b[17][1]++;
      }
      cov_1kaxqa4byh().s[36]++;
      return _moment["default"].utc(date).format();
    }
  }, {
    key: "weekFollowingDay",
    value: function weekFollowingDay() {
      var day = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kaxqa4byh().b[18][0]++, 'monday');
      var dateInput = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1kaxqa4byh().b[19][0]++, undefined);
      cov_1kaxqa4byh().f[4]++;
      // Get Start Of Input Date
      var startOfInput = (cov_1kaxqa4byh().s[37]++, dateInput ? (cov_1kaxqa4byh().b[20][0]++, new Date(dateInput)) : (cov_1kaxqa4byh().b[20][1]++, new Date()));
      cov_1kaxqa4byh().s[38]++;
      startOfInput.setUTCHours(0, 0, 0, 0);
      var today = (cov_1kaxqa4byh().s[39]++, (0, _moment["default"])(dateInput));
      var newDates;
      var startWeek;
      /**
       * Checks if the todays date is less than
       * the weekStart date && they are in
       * the same year
       */
      cov_1kaxqa4byh().s[40]++;
      if ((cov_1kaxqa4byh().b[22][0]++, today.dayOfYear() < _moment["default"].utc(dateInput).day(day).dayOfYear()) && (cov_1kaxqa4byh().b[22][1]++, today.year() === _moment["default"].utc(dateInput).day(day).year())) {
        cov_1kaxqa4byh().b[21][0]++;
        cov_1kaxqa4byh().s[41]++;
        startWeek = _moment["default"].utc(startOfInput).day(day).subtract(1, 'day').subtract(1, 'weeks');
        cov_1kaxqa4byh().s[42]++;
        newDates = Array(7).fill(0).map(function () {
          cov_1kaxqa4byh().f[5]++;
          cov_1kaxqa4byh().s[43]++;
          return startWeek.add(1, 'day').clone();
        });
        cov_1kaxqa4byh().s[44]++;
        return newDates;
      } else {
        cov_1kaxqa4byh().b[21][1]++;
      }
      cov_1kaxqa4byh().s[45]++;
      startWeek = _moment["default"].utc(startOfInput).day(day).subtract(1, 'day');
      cov_1kaxqa4byh().s[46]++;
      newDates = Array(7).fill(0).map(function () {
        cov_1kaxqa4byh().f[6]++;
        cov_1kaxqa4byh().s[47]++;
        return startWeek.add(1, 'day').clone();
      });
      cov_1kaxqa4byh().s[48]++;
      return newDates;
    }
  }, {
    key: "weekFollowingDate",
    value: function weekFollowingDate(day) {
      cov_1kaxqa4byh().f[7]++;
      var startWeek = (cov_1kaxqa4byh().s[49]++, _moment["default"].utc(day));
      var newDates = (cov_1kaxqa4byh().s[50]++, Array(7).fill(0).map(function (_, i) {
        cov_1kaxqa4byh().f[8]++;
        cov_1kaxqa4byh().s[51]++;
        switch (i) {
          case i === 6:
            cov_1kaxqa4byh().b[23][0]++;
            cov_1kaxqa4byh().s[52]++;
            return startWeek.add(1, 'day').endOf('day').clone();
          default:
            cov_1kaxqa4byh().b[23][1]++;
            cov_1kaxqa4byh().s[53]++;
            return startWeek.add(1, 'day').clone();
        }
      }));
      cov_1kaxqa4byh().s[54]++;
      return newDates;
    }

    /**
     * @param {String} start
     * @param {String} end
     * @param {String} date
     * @returns - {Boolean} if date is between start & end (includes edges)
     */
  }, {
    key: "DateIsBetween",
    value: function DateIsBetween(start, end, date) {
      cov_1kaxqa4byh().f[9]++;
      var dayStarts = (cov_1kaxqa4byh().s[55]++, {
        date: _moment["default"].utc(date).startOf('day').format(),
        start: _moment["default"].utc(start).startOf('day').format(),
        end: _moment["default"].utc(end).startOf('day').format()
      });
      cov_1kaxqa4byh().s[56]++;
      return _moment["default"].utc(dayStarts.date).isBetween(dayStarts.start, dayStarts.end, null, '[]');
    }

    /**
     * @param {String} date0
     * @param {String} date1
     * @returns - {Boolean} if date0 is after date1
     */
  }, {
    key: "DateIsAfter",
    value: function DateIsAfter(date0, date1) {
      cov_1kaxqa4byh().f[10]++;
      cov_1kaxqa4byh().s[57]++;
      return _moment["default"].utc(date0).isAfter(_moment["default"].utc(date1));
    }

    /**
     * @param {String} date0
     * @param {String} date1
     * @returns - {Boolean} if date0 is before date1
     */
  }, {
    key: "DateIsBefore",
    value: function DateIsBefore(date0, date1) {
      cov_1kaxqa4byh().f[11]++;
      cov_1kaxqa4byh().s[58]++;
      return _moment["default"].utc(date0).isBefore(_moment["default"].utc(date1), 'day');
    }

    /**
     *
     * @param {Object} start - Date
     * @param {Object} end - Date
     * @param {Object} period - periodStart, periodEnd
     * @returns {Object} period - periodStart, periodEnd
     */
  }, {
    key: "timesheetPeriod",
    value: function timesheetPeriod() {
      var start = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_1kaxqa4byh().b[24][0]++, this.currentWeek[0]);
      var end = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (cov_1kaxqa4byh().b[25][0]++, this.currentWeek[6]);
      var period = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : (cov_1kaxqa4byh().b[26][0]++, this.currentPeriod);
      cov_1kaxqa4byh().f[12]++;
      cov_1kaxqa4byh().s[59]++;
      return {
        periodStart: this.calculatePeriodStart(start, period),
        periodEnd: this.calculatePeriodEnd(end, period)
      };
    }
  }]);
  return TimeSheets;
}();
var _default = exports["default"] = {
  resource: 'Timesheet',
  url: '/api/Timesheet',
  TimeSheets: TimeSheets
};